import { useIntl } from "react-intl";

import { ArticleCta } from "@/libraries/design/components/article-cta/src/article-cta";

interface TemplateCtaProps {
    title: string;
    copy: string;
    buttonHref: string;
    linkHref: string;
}

/**
 * @deprecated - Please use UniformArticleCta at /uniform/components/article-cta instead
 */
const UniformTemplateCta = (props: TemplateCtaProps) => {
    const intl = useIntl();
    const articleCtaProps = {
        ...props,
        buttonText: intl.formatMessage({
            id: "template-cta.use-template",
            defaultMessage: "Use template"
        })
    };
    return <ArticleCta {...articleCtaProps} />;
};

export default UniformTemplateCta;
